import { Drawer } from 'almanac-ui/Drawer/Drawer'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import Styles from '../Panels.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { SEOAnalysis as SEOAnalysisIcon } from 'blaze-ui/icons/36'
import { PlagiarismCheck as BlazePlagiarismCheckIcon } from 'blaze-ui/icons/36'
import cx from 'classnames'
import { Text } from 'blaze-ui/Text/Text'
import { ArrowRight } from 'blaze-ui/icons'
import { PlagiarismDetection } from './PlagiarismDetection'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

export const PlagiarismDetectionPanel = observer(() => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const rightRailPanelStore = useRootStore().rightRailPanelStore

  const articleId = useRootStore().docStore?.articleId
  return (
    <>
      <Drawer.Header>
        <div className={Styles.header}>
          <div className={Styles.headerInner}>
            {!isSystemRedesignEnabled && <BlazePlagiarismCheckIcon size={20} />}
            {isSystemRedesignEnabled ? <Text>Plagiarism Check</Text> : <Heading level={4}>Plagiarism Check</Heading>}
          </div>
          <Drawer.CloseButton />
        </div>
      </Drawer.Header>
      <Drawer.Body>
        <PlagiarismDetection key={articleId}>
          {!isSystemRedesignEnabled && (
            <div className={cx(Styles.nextStepButton, Styles.fixed)} onClick={() => rightRailPanelStore.show('seo')}>
              <SEOAnalysisIcon />
              <div className={Styles.nextAction}>
                <Text variant="label">Next step</Text>
                <Heading level={5}>View SEO Analysis</Heading>
              </div>
              <div className={Styles.arrowRight}>
                <ArrowRight />
              </div>
            </div>
          )}
        </PlagiarismDetection>
      </Drawer.Body>
    </>
  )
})
